import { FormControl, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import { StyledInputLabel, StyledSelect } from './styled';

type PropTypes = {
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
};

const InstrumentSelector = ({ value, onChange, disabled }: PropTypes) => {
  const { t } = useTranslation();

  const { data: instrumentsData } =
    aiMusicGeneratorApi.useGetInstrumentsQuery();

  const inputLabel = t('aiMusicGenerator:userLoopUploadModal:instrumentType');

  return (
    <FormControl data-testid="form-control" fullWidth disabled={disabled}>
      <StyledInputLabel id="instrument-type" data-testid="input-label">
        {inputLabel}
      </StyledInputLabel>
      <StyledSelect
        labelId="instrument-type-label"
        data-testid="instrument-type-select"
        value={value ?? ''}
        label={inputLabel}
        disabled={disabled}
        onChange={({ target }: { target: { value: string } }) =>
          onChange(target.value)
        }
      >
        {instrumentsData?.map((instrument) => (
          <MenuItem key={instrument} value={instrument}>
            {instrument}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default InstrumentSelector;
